module.exports = __webpack_public_path__ + "img/icon_socio.f6f593f3.svg";